module.exports = __webpack_public_path__ + "img/stock4.add313dc.png";